export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    title: that.$l('table_input_bizPersonName') || '跟单人员',
    field: 'bizPersonName',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('table_input_planCount') || '在手订单',
    field: 'planCount',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_inputCount') || '录入订单',
    field: 'inputCount',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_invalidCount') || '无效订单',
    field: 'invalidCount',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_rateOfProgress') || '录入进度',
    field: 'rateOfProgress',
    minWidth: 230,
    headerAlign: 'center',
    align: 'left',
    sortable: true,
    sortType: 'number',
    slots: { default: 'rateOfProgress' }
  },
  {
    title: that.$l('table_input_salePriceAmountRmb') || '收入',
    field: 'v_salePriceAmountRmb',
    minWidth: 140,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_priceAmountRmb') || '成本',
    field: 'v_priceAmountRmb',
    minWidth: 140,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    field: 'modifyTime',
    align: 'center',
    minWidth: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'String'
  }
]
